import { type ReduxUser } from 'models';

export const canCreateProgram = ({ viewer }: { viewer: ReduxUser }) =>
  viewer.superadmin || viewer.admin_organizations.length > 0;
